import { ButtonBase } from '@mui/material';

import { useTheme } from '@sbv-clients/ui-shared';

import { LineIcon } from './line-icon';

export const ViewAllButton = ({ onClick }: { onClick?: () => void }) => {
  const theme = useTheme();
  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        gap: '4px',
        fontSize: '13px',
        fontWeight: 500,
        color: theme.colors.primary.main,
        '&:hover': { textDecoration: 'underline' },
      }}
    >
      View all
      <LineIcon name="arrow" size={14} />
    </ButtonBase>
  );
};
